import { render, staticRenderFns } from "./ClientsRangeSlider.vue?vue&type=template&id=01d4f0b6"
import script from "./ClientsRangeSlider.vue?vue&type=script&lang=js"
export * from "./ClientsRangeSlider.vue?vue&type=script&lang=js"
import style0 from "./ClientsRangeSlider.vue?vue&type=style&index=0&id=01d4f0b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports